export default function CreateImageIcon({ className = '', size = 26 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 23"
      className={className}
    >
      <g
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.1"
      >
        <path d="m8.25,10.5c-0.69,0 -1.25,0.56 -1.25,1.25c0,0.69 0.56,1.25 1.25,1.25l0.01,0c0.69,0 1.25,-0.56 1.25,-1.25c0,-0.69 -0.56,-1.25 -1.25,-1.25l-0.01,0z" />
        <path d="m7.75,7.25l-1.75,0c-1.24,0 -2.25,1.01 -2.25,2.25l0,8.16c0,0.01 0,0.02 0,0.03l0,0.81c0,1.24 1.01,2.25 2.25,2.25l9,0c1.24,0 2.25,-1.01 2.25,-2.25l0,-1.75l0,-1.5l0,-5.75c0,-1.24 -1.01,-2.25 -2.25,-2.25l-5.75,0l-1.5,0zm7.25,1.5c0.41,0 0.75,0.34 0.75,0.75l0,6.46l-2.26,-2.11c-0.7,-0.64 -1.73,-0.78 -2.57,-0.35l-5.67,2.94l0,-6.94c0,-0.41 0.34,-0.75 0.75,-0.75l9,0zm-9,10.5c-0.41,0 -0.75,-0.34 -0.75,-0.75l0,-0.37l6.36,-3.29c0.28,-0.15 0.62,-0.1 0.85,0.11l3.29,3.05l0,0.5c0,0.41 -0.34,0.75 -0.75,0.75l-9,0z" transform="rotate(-6.87216 10.5 14)" />
        <path d="m11.04,3.97c-1.23,-0.17 -2.37,0.69 -2.54,1.92l-0.24,1.73l1.49,0.2l0.24,-1.73c0.06,-0.41 0.44,-0.7 0.85,-0.64l8.92,1.23c0.41,0.06 0.7,0.44 0.64,0.85l-1.23,8.92c-0.06,0.41 -0.44,0.7 -0.85,0.64l-1.73,-0.24l-0.2,1.49l1.73,0.24c1.23,0.17 2.37,-0.69 2.54,-1.92l1.23,-8.92c0.17,-1.23 -0.69,-2.37 -1.92,-2.54l-8.92,-1.23l-0.01,0z" />
      </g>
    </svg>
  );
}
